export default "__VITE_ASSET__CtVdLllq__"